
export const AWS_CREDENTIALS: any = {
  region: 'ap-south-1',
  storage: 'elevok-bucket',
};
export const reputationPicture = 'https://elevok-bucket.s3.ap-south-1.amazonaws.com/loyalcraft/reputation_512.gif';
